export default __webpack_public_path__ + "static/media/facebook.177e21a8.png";